<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <div class="pt-5 my-account">
            <b-container>
                <b-row>
                    <b-col cols="12" md="3">
                        <Restricted_area_menu/>
                    </b-col>
                    <b-col cols="12" md="9" class="mb-5">
                        <div class="my-account-block">
                            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
                                <form action="#" method="post" name="register_form" class="form_default mt-4" @submit.prevent="handleSubmit(onSubmit)">
                                    <fieldset>
                                        <legend class="my-account-change-data-title mb-4"> Meus dados </legend>
                                        <b-row>
                                            <b-col cols="12" lg="6">
                                                <ValidationProvider name="nome completo" rules="required|fullname" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_name" class="my-account-change-label">{{ person.type === 'PJ' ? 'Nome fantasia' : 'Nome completo' }}<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="text" id="register_name" name="register_name" class="form-control" v-model="person.name" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="6">
                                                <ValidationProvider name="e-mail" rules="required|email" vid="email" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_email" class="my-account-change-label">E-mail<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="email" id="register_email" name="register_email" class="form-control font-italic" v-model="person.email" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <template v-if="person.type === 'PJ'">
                                                <b-col cols="12" lg="4">
                                                    <ValidationProvider name="CNPJ" rules="required|cnpj" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="register_cnpj" class="my-account-change-label">CNPJ<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <the-mask type="tel" inputmode="numeric" id="register_cnpj" name="register_cnpj" class="form-control" v-model="person.cnpj" :class="classes" :mask="['##.###.###/####-##']" :masked="true"/>
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" lg="8">
                                                    <ValidationProvider name="razão social" rules="required|fullname" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="razao_social" class="my-account-change-label">Razão social<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <input type="text" class="form-control" id="razao_social" name="razao_social" v-model="person.company_name" :class="classes">
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>

                                                <b-col cols="12" lg="4">
                                                    <ValidationProvider name="inscrição estadual" rules="" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="insc_estadual" class="my-account-change-label">Inscrição estadual<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <input type="text" class="form-control" id="insc_estadual" name="insc_estadual" v-model="person.state_registration" :class="classes">
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" lg="4">
                                                    <ValidationProvider name="inscrição municipal" rules="required" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="insc_municipal" class="my-account-change-label">Inscrição municipal<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <input type="text" class="form-control" id="insc_municipal" name="insc_municipal" v-model="person.municipal_inscription" :class="classes">
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                            </template>
                                            <template v-else>
                                                <b-col cols="12" lg="4">
                                                    <ValidationProvider name="CPF" rules="required|cpf" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="register_cpf" class="my-account-change-label">CPF<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <the-mask type="tel" inputmode="numeric" id="register_cpf" name="register_cpf" class="form-control" v-model="person.cpf" :class="classes" :mask="['###.###.###-##']" :masked="true"/>
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" lg="4">
                                                    <ValidationProvider name="data de nascimento" rules="required|dateage" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="register_birthdate" class="my-account-change-label">Data de nascimento<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <the-mask type="tel" inputmode="numeric" id="register_birthdate" name="register_birthdate" class="form-control" v-model="person.birth" :class="classes" :mask="['##/##/####']" :masked="true"/>
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col cols="12" lg="4">
                                                    <ValidationProvider name="sexo" rules="required" slim v-slot="{ errors, classes, required }">
                                                        <div class="form-group">
                                                            <label for="register_gender" class="my-account-change-label">Sexo<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <select id="register_gender" name="register_gender" class="form-control" v-model="person.gender" :value="person.gender" :class="classes">
                                                                <option value="F">Feminíno</option>
                                                                <option value="M">Masculino</option>
                                                                <option value="X">Não informar</option>
                                                            </select>
                                                            <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                        </div>
                                                    </ValidationProvider>
                                                </b-col>
                                            </template>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="12" lg="4">
                                                <ValidationProvider name="telefone" :rules="{ required: true, regex: /^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/ }" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_phone" class="my-account-change-label">Telefone<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <the-mask type="tel" inputmode="numeric" id="register_phone" name="register_phone" class="form-control" v-model="person.phone" :class="classes" :mask="['(##) ####-####', '(##) #####-####']" :masked="true"/>
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="4">
                                                <ValidationProvider name="celular" :rules="{ required: false, regex: /^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/ }" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_cellphone" class="my-account-change-label">Celular<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <the-mask type="tel" inputmode="numeric" id="register_cellphone" name="register_cellphone" class="form-control" v-model="person.cellphone" :class="classes" :mask="['(##) ####-####', '(##) #####-####']" :masked="true"/>
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="12" lg="3">
                                                <ValidationProvider name="CEP" :rules="{ required: true, regex: /^\d{5}-?\d{3}$/ }" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <div class="d-flex justify-content-between">
                                                            <label for="register_cep" class="my-account-change-label">CEP<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                            <small><a href="http://www.buscacep.correios.com.br/sistemas/buscacep" target="_blank" rel="nofollow" title="Não sabe?" class="register-forget">Não sabe?</a></small>
                                                        </div>
                                                        <the-mask type="tel" inputmode="numeric" id="register_cep" name="register_cep" class="form-control" v-model="address.zip_code" :class="classes" :mask="['#####-###']" :masked="true" @input="getCep(address.zip_code)"/>
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="6">
                                                <ValidationProvider name="endereço" rules="required" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_address" class="my-account-change-label">Endereço<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="text" id="register_address" name="register_address" class="form-control" v-model="address.address" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="3">
                                                <ValidationProvider name="número" rules="required" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_addressNumber" class="my-account-change-label">N&deg;<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="tel" inputmode="numeric" id="register_addressNumber" name="register_addressNumber" class="form-control" v-model="address.number" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="6">
                                                <ValidationProvider name="complemento" rules="" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_addressComplement" class="my-account-change-label">Complemento<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="text" id="register_addressComplement" name="register_addressComplement" class="form-control" v-model="address.complement" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="6">
                                                <ValidationProvider name="bairro" rules="required" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_addressNeighbourhood" class="my-account-change-label">Bairro<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="text" id="register_addressNeighbourhood" name="register_addressNeighbourhood" class="form-control" v-model="address.neighbourhood" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="4">
                                                <ValidationProvider name="cidade" rules="required" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_addressCity" class="my-account-change-label">Cidade<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="text" id="register_addressCity" name="register_addressCity" class="form-control" v-model="address.city" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="4">
                                                <ValidationProvider name="UF" rules="required" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_addressState" class="my-account-change-label">UF<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <select id="register_addressState" name="register_addressState" class="form-control" v-model="address.state" :class="classes">
                                                            <option value="" disabled selected>Selecione</option>
                                                            <option value="AC">Acre</option>
                                                            <option value="AL">Alagoas</option>
                                                            <option value="AP">Amapá</option>
                                                            <option value="AM">Amazonas</option>
                                                            <option value="BA">Bahia</option>
                                                            <option value="CE">Ceará</option>
                                                            <option value="DF">Distrito Federal</option>
                                                            <option value="ES">Espírito Santo</option>
                                                            <option value="GO">Goiás</option>
                                                            <option value="MA">Maranhão</option>
                                                            <option value="MT">Mato Grosso</option>
                                                            <option value="MS">Mato Grosso do Sul</option>
                                                            <option value="MG">Minas Gerais</option>
                                                            <option value="PA">Pará</option>
                                                            <option value="PB">Paraíba</option>
                                                            <option value="PR">Paraná</option>
                                                            <option value="PE">Pernambuco</option>
                                                            <option value="PI">Piauí</option>
                                                            <option value="RJ">Rio de Janeiro</option>
                                                            <option value="RN">Rio Grande do Norte</option>
                                                            <option value="RS">Rio Grande do Sul</option>
                                                            <option value="RO">Rondônia</option>
                                                            <option value="RR">Roraima</option>
                                                            <option value="SC">Santa Catarina</option>
                                                            <option value="SP">São Paulo</option>
                                                            <option value="SE">Sergipe</option>
                                                            <option value="TO">Tocantins</option>
                                                        </select>
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="12" lg="4">
                                                <ValidationProvider name="país" rules="required" slim v-slot="{ errors, classes, required }">
                                                    <div class="form-group">
                                                        <label for="register_addressCountry" class="my-account-change-label">País<abbr title="Obrigatório" v-if="required">*</abbr></label>
                                                        <input type="text" id="register_addressCountry" name="register_addressCountry" class="form-control" v-model="address.country" :class="classes">
                                                        <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                    <FormMessage :msg="msg_form" :type="msg_form_type"></FormMessage>
                                    <div class="d-flex justify-content-end mb-5 mt-3">
                                        <button type="submit" class="btn-default btn-square" :disabled="sending">
                                            {{ sending ? 'Enviando' : 'ALTERAR DADOS' }}
                                        </button>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '~/components/Breadcrumb';
import Restricted_area_menu from "~/components/Restricted_area_menu";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {TheMask} from "vue-the-mask";
import FormMessage from "~/components/FormMessage";
const Cookie = process.client ? require('js-cookie') : undefined
export default {
    head() {
        return {
            title: 'Meus dados - Minha conta',
            // meta: [
            //     {hid: 'og:image', property: 'og:image', content: 'https://' + this.host + '/share.jpg'},
            //     {hid: 'og:image:height', property: 'og:image:height', content: '315'},
            //     {hid: 'og:image:width', property: 'og:image:width', content: '600'},
            //     {hid: 'og:url', property: 'og:url', content: 'https://' + this.host + this.$route.fullPath}
            // ]
        }
    },
    middleware: 'authenticated',
    components: {
        Restricted_area_menu,
        Breadcrumb,
        FormMessage,
        ValidationProvider,
        ValidationObserver,
        TheMask
    },
    data: () => {
        return {
            msg_form: '',
            msg_form_type: '',
            sending: false,
            token: "",
            person: {
                email: '',
                conf_email: '',
                password: '',
                conf_password: '',
                type: 'PF',
                name: '',
                cpf: '',
                gender: '',
                birth: '',
                // razao_social: '',
                company_name: '',
                cnpj: '',
                state_registration: '',
                municipal_inscription: '',
                phone: '',
                cellphone: '',
            },
            address: {
                zip_code: '',
                address: '',
                number: '',
                complement: '',
                neighbourhood: '',
                city: '',
                uf: '',
                country: ''
            }
        }
    },
    computed: {
        breadcrumb() {
            let breadcrumb = [
                {
                    name: 'Home',
                    link: '/'
                },
                {
                    name: 'Minha conta',
                    link: '/conta/meus-dados/'
                }
            ];
            breadcrumb.push({
                name: 'Meus dados',
                link: null
            });
            return breadcrumb;
        },
    },
    methods: {
        async onSubmit() {
            try {
                const params = new URLSearchParams();
                this.sending = true;

                params.append('nome', this.person.name)
                params.append('email', this.person.email)

                params.append('data_nascimento', this.person.birth)
                params.append('sexo', this.person.gender)
                params.append('telefone', this.person.phone)
                params.append('celular', this.person.cellphone)

                params.append('razao_social', this.person.company_name)
                params.append('inscestadual', this.person.state_registration)
                params.append('inscmunicipal', this.person.municipal_inscription)

                params.append('cep', this.address.zip_code)
                params.append('endereco', this.address.address)
                params.append('numero', this.address.number)
                params.append('referencia', this.address.complement)
                params.append('bairro', this.address.neighbourhood)
                params.append('cidade', this.address.city)
                params.append('uf', this.address.state)
                params.append('pais', this.address.country)

                // params.append('', 'nome_contato')
                // params.append('', 'telefone_contato')
                // params.append('', 'email_contato')
                params.append('metodo', 'update_person')
                return this.$axios.$post('?p=erp_pessoas_api_v1', params)
                    .then((response) => {
                        if (response.status === 'sucesso') {
                            let firstname = this.person.name.split(' ')
                            this.msg_form = 'Dados atualizados!';
                            this.msg_form_type = 'success';
                            const auth = {
                                access_token: this.$store.state.auth.access_token,
                                person_name: this.person.name,
                                firstname: firstname[0]
                            }
                            this.$store.commit('setAuth', auth)
                            Cookie.set('auth', auth, {path: '/'})
                        } else {
                            this.msg_form = 'Erro ao atualizar: ' + response.msg.replace(':', '');
                            this.msg_form_type = 'error';
                        }
                    });
            } catch (e) {
                console.error(e)
                this.msg_form = 'Erro ao atualizar dados!';
                this.msg_form_type = 'error';
            }
        },
        getCep: function (cep) {
            this.cepIsValid = false;
            if (cep === undefined) {
                return;
            }
            cep = cep.replace(/\D+/g, "");
            if (cep.length !== 8) {
                return;
            }
            const params = new URLSearchParams();
            params.append('cep', cep);
            this.$axios.$post('/cep.php', params)
                .then((data) => {
                    if (data.tipo !== 'sucesso') {
                        throw data.msg;
                    }
                    this.address.address = (data.dados.tipo_logradouro + ' ' + data.dados.logradouro).trim();
                    this.address.neighbourhood = (data.dados.bairro).trim();
                    this.address.city = (data.dados.cidade).trim();
                    this.address.state = (data.dados.uf).toUpperCase().trim();
                    this.address.country = 'Brasil';
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
    },
    watch: {
        sending(newvalue) {
            if (newvalue) {
                this.msg_form = ''
            }
        },
        msg_form(newvalue) {
            if (newvalue !== '') {
                this.sending = false
            }
        }
    },
    async fetch() {
        await this.$axios.$post(`?p=erp_pessoas_api_v1&metodo=person_data`).then((res) => {
            if (res.status === 'success') {
                this.person = res.person
                this.address = res.address
                this.person.conf_email = this.person.email
                if ('birth' in this.person) {
                    if (new Date(this.person.birth) !== "Invalid Date" && !isNaN(new Date(this.person.birth))) {
                        let brith_date = new Date(this.person.birth + 'T00:00:00');
                        this.person.birth = brith_date.toLocaleString('pt-BR').split(' ')[0];
                    }
                }
                if (this.person.type === 'PJ') {
                    this.person.name = this.person.trade_name;
                }
            }
        })
    },
    fetchOnServer: false
}
</script>
